import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, pdfManager, toggle, setDataModal,
    FetchData, Helpers,

    defaultData,

    //------------- Forms
    Forms,

    globalStates

}) => {

    const { numberFormatter, convertToFloat, drawPaymentTicket } = Helpers

    // Redondea a 2 decimales el valor "clean_" que se envía al SP; sin esto la
    // division monto/tipo_cambio arrastra precision flotante completa (ej. 4146.862820512821)
    // aunque el campo visible ya se vea formateado via numberFormatter.format()
    const round2 = (value) => Math.round((value + Number.EPSILON) * 100) / 100

    // Estado para bloquear botones mientras una operación al backend está en curso
    const [pending, setPending] = useState({})

    const withPending = (key, fn) => async (...args) => {
        if (pending[key]) return
        setPending(p => ({ ...p, [key]: true }))
        try {
            return await fn(...args)
        } finally {
            setPending(p => ({ ...p, [key]: false }))
        }
    }

    const openModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }

    const closeModal = () => {
        toggle()
    }

    const handleClickFechtVehicleCredits = async (campo, identificador) => {
        const { fetchAllCredits: { setParamsToSearch, executeFetchAllCredits }, fetchAllCreditsPayments: { setCreditPayments } } = FetchData
        const { FormRequestGlobal: { onResetForm, setFormState } } = Forms

        setParamsToSearch({ campo: campo, identificador: identificador })
        onResetForm()
        setCreditPayments([])
        await executeFetchAllCredits()

        setFormState(prevState => ({
            ...prevState,
            [campo]: identificador.replace(/%/g, "")
        }))
    }

    const handleClickSearchPayments = async () => {
        const { fetchAllCreditsPayments: { setParamsToSearch, executeFetchAllCreditPayments } } = FetchData
        const { FormRequestGlobal: { formState, setFormState } } = Forms
        const { extractIdVehicle } = Helpers

        const { statusCode, statusMessage, idcredito } = extractIdVehicle(formState.identificador);

        if (!statusCode) {
            const messageCustom = {
                message: statusMessage,
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        } else {
            setFormState(prevState => ({
                ...prevState,
                'idcredito': idcredito
            }))
        }
        // onResetForm()
        setParamsToSearch({ idcredito: idcredito })


        executeFetchAllCreditPayments()
    }

    const handleKeyDown = (event) => {
        const { fetchAllCreditsPayments: { setParamsToSearch, executeFetchAllCreditPayments } } = FetchData
        const { FormRequestGlobal: { formState, setFormState } } = Forms
        const { extractIdVehicle } = Helpers

        if (event.key === 'Enter') {
            event.preventDefault();
            const { statusCode, statusMessage, idcredito } = extractIdVehicle(formState.identificador);
            if (!statusCode) {
                const messageCustom = {
                    message: statusMessage,
                    title: 'FAIL',
                    rows: []
                }
                alertMessage(messageCustom)
                return
            } else {
                setFormState(prevState => ({
                    ...prevState,
                    'idcredito': idcredito
                }))
            }

            setParamsToSearch({ idcredito: idcredito })
            executeFetchAllCreditPayments()
        }
    };


    const handleClickShowModal = (_, title, compont, dataRequest, modalOpeningMode) => {

        const { setModalOpeningMode, setComponentModalDeposit } = globalStates

        const { FormRequestGlobal: { setFormState } } = Forms

        const { fetchAllDeposits: { executeFetchAllDeposits } } = FetchData;

        const { idpago } = dataRequest

        if (compont === "deposits-table") executeFetchAllDeposits()

        setFormState(prevState => ({
            ...prevState,
            'idpago': idpago
        }))

        setModalOpeningMode(modalOpeningMode)
        setComponentModalDeposit(compont)
        openModal(_, title, compont, dataRequest)
    }

    const handleClickCloseModal = () => {

        //HOOKS
        const { FormDeposit } = Forms
        const { onResetForm } = FormDeposit
        onResetForm()
        closeModal()
    }

    const handleChangeAmount = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState, onInputChangeForNumber } = FormDeposit

        onInputChangeForNumber(event)

        const { deposito_tipo_cambio } = formState

        const { value } = event.target

        onInputChangeForNumber(event)

        const clean_value = convertToFloat(value)

        //Verificamos si tiene data
        const tipo_cambio = deposito_tipo_cambio !== '' ? parseFloat(deposito_tipo_cambio) : 0;


        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                deposito_quetzales: numberFormatter.format(clean_value * tipo_cambio),
                deposito_dolares: numberFormatter.format(clean_value),
                clean_deposito_quetzales: round2(clean_value * tipo_cambio),
                clean_deposito_dolares: round2(clean_value)
            }))
        } else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                deposito_quetzales: numberFormatter.format(clean_value),
                deposito_dolares: numberFormatter.format(clean_value / tipo_cambio),
                clean_deposito_quetzales: round2(clean_value),
                clean_deposito_dolares: round2(clean_value / tipo_cambio)
            }))
        }
    }

    const handleChangeTypeCurrency = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState } = FormDeposit
        const { clean_deposito_monto, deposito_tipo_cambio } = formState

        const { name, value } = event.target

        //Verificamos si tiene data
        const tipo_cambio = deposito_tipo_cambio !== '' ? deposito_tipo_cambio : 0;

        if (value === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto * tipo_cambio),
                deposito_dolares: numberFormatter.format(clean_deposito_monto),
                clean_deposito_quetzales: round2(clean_deposito_monto * tipo_cambio),
                clean_deposito_dolares: round2(clean_deposito_monto)
            }))
        } else if (value === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto),
                deposito_dolares: numberFormatter.format(clean_deposito_monto / tipo_cambio),
                clean_deposito_quetzales: round2(clean_deposito_monto),
                clean_deposito_dolares: round2(clean_deposito_monto / tipo_cambio)
            }))
        }
    }

    const handleChangeExchangeRate = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState } = FormDeposit
        const { clean_deposito_monto } = formState

        const { name, value } = event.target

        //Verificamos si tiene data
        const tipo_cambio = value !== '' ? parseFloat(value) : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto * tipo_cambio),
                deposito_dolares: numberFormatter.format(clean_deposito_monto),
                clean_deposito_quetzales: round2(clean_deposito_monto * tipo_cambio),
                clean_deposito_dolares: round2(clean_deposito_monto)
            }))
        } else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto),
                deposito_dolares: (tipo_cambio === 0) ? 0 : numberFormatter.format(clean_deposito_monto / tipo_cambio),
                clean_deposito_quetzales: round2(clean_deposito_monto),
                clean_deposito_dolares: (tipo_cambio === 0) ? 0 : round2(clean_deposito_monto / tipo_cambio)
            }))
        } else {
            setFormState(prevState => ({
                ...prevState,
                [name]: value
            }))
        }
    }

    const handleClickDownloadImage = withPending('downloadImage', async (customFileName, openUrl) => {

        try {
            const response = await fetch(openUrl);
            const blob = await response.blob();

            // Crear un enlace temporal
            const enlaceTemporal = document.createElement('a');
            enlaceTemporal.href = window.URL.createObjectURL(blob);
            enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
            document.body.appendChild(enlaceTemporal);

            // Simular clic en el enlace para iniciar la descarga
            enlaceTemporal.click();

            // Eliminar el enlace temporal
            document.body.removeChild(enlaceTemporal);

            toast.success('Se ha descargado la imagen');

        } catch (error) {
            console.error('Error al descargar la imagen', error);
        }

    })

    const onSubmitFormDeposits = withPending('submitDeposit', async (e) => {

        e.preventDefault()

        const { FormDeposit, FormRequestGlobal } = Forms
        const { formState, onResetForm } = FormDeposit
        const formStateGlobal = FormRequestGlobal.formState

        const {
            fetchAllCreditsPayments: { executeFetchAllCreditPayments },
            fetchInfoDebtsSummary: { executeFetchDebtsSummary }
        } = FetchData

        const { getCurrentDate, extractIdVehicle } = Helpers

        const { idcredito } = extractIdVehicle(FormRequestGlobal.identificador)

        if (formState.movimiento_tipo === '') {
            const messageCustom = {
                message: 'Debe seleccionar un tipo de movimiento',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        if (formState.deposito_moneda === '') {
            const messageCustom = {
                message: 'Debe seleccionar una moneda',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        if (formState.movimiento_tipo === 'EFECTIVO') {

            if (formState.idcaja === '') {
                const messageCustom = {
                    message: 'Debe seleccionar una caja',
                    title: 'FAIL',
                    rows: []
                }
                alertMessage(messageCustom)
                return
            }
        }

        const { isConfirmed } = await Swal.fire({
            title: '¿Está seguro de procesar este pago?',
            text: 'Una vez procesado, esta operación no podrá revertirse.',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar'
        })

        if (!isConfirmed) return

        if (formState.movimiento_tipo === 'EFECTIVO') {

            const _data = {
                idpago: formStateGlobal.idpago,
                idcredito: idcredito,
                deposito_usuario: user.username,
                fecha_creo: getCurrentDate(),
                deposito_fecha: formState.deposito_fecha,
                movimiento_tipo: formState.movimiento_tipo,
                deposito_monto: formState.clean_deposito_monto,
                deposito_moneda: formState.deposito_moneda,
                deposito_tipo_cambio: parseFloat(formState.deposito_tipo_cambio),
                deposito_quetzal: formState.clean_deposito_quetzales,
                deposito_dolares: formState.clean_deposito_dolares,
                idcaja: formState.idcaja,
                saldo_anterior: formStateGlobal.saldo_cuota_anterior,
                deposito_observaciones: formState.deposito_observaciones,
                usuario_creo: user.username,
                fecha_creo: getCurrentDate()
            }

            await marvarApi.post(`/credits/mgmt-payments/create-deposit-cash`, _data)
                .then(async ({ data }) => {

                    alertMessage(data)

                    if (data.title === 'OK') {
                        onResetForm()
                        executeFetchAllCreditPayments()
                        executeFetchDebtsSummary()
                        closeModal()

                        const idmovimiento_actual = data.rows?.[0]?.idmovimiento_actual
                        if (idmovimiento_actual) {
                            await handleClickDownloadTicket(idmovimiento_actual)
                        } else {
                            toast.warn('No se pudo imprimir el recibo', {
                                position: "top-right",
                                theme: "colored"
                            })
                        }
                    }

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }

        if (formState.movimiento_tipo === 'DEPOSITO') {

            if (formState.idbanco === '') {
                const messageCustom = {
                    message: 'Debe seleccionar un banco',
                    title: 'FAIL',
                    rows: []
                }
                alertMessage(messageCustom)
                return
            }

            if (formState.acceptedFiles.length <= 0) {

                const messageCustom = {
                    message: 'Debe cargar el comprobante para poder registrar el deposito',
                    title: 'FAIL',
                    rows: []
                }

                alertMessage(messageCustom)

                return
            }

            const _data = new FormData();

            _data.append('idpago', formStateGlobal.idpago)
            _data.append('idbanco', formState.idbanco)
            _data.append('idcredito', idcredito)
            _data.append('movimiento_tipo', formState.movimiento_tipo)
            _data.append('deposito_fecha', formState.deposito_fecha)
            _data.append('deposito_usuario', user.username)
            _data.append('deposito_monto', formState.clean_deposito_monto)
            _data.append('deposito_moneda', formState.deposito_moneda)
            _data.append('deposito_tipo_cambio', formState.deposito_tipo_cambio)
            _data.append('deposito_quetzal', formState.clean_deposito_quetzales)
            _data.append('deposito_dolares', formState.clean_deposito_dolares)
            _data.append('boleta_numero', formState.boleta_numero)
            _data.append('usuario_creo', user.username)
            _data.append('fecha_creo', getCurrentDate())

            formState.acceptedFiles.forEach((file, index) => {
                _data.append(`images`, file);
            });

            await marvarApi.post(`/credits/mgmt-payments/create-deposit-bank`, _data)
                .then(async ({ data }) => {
                    alertMessage(data)

                    if (data.title === 'OK') {
                        // executeFetchAllDeposits()
                        onResetForm()
                        closeModal()
                    }

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }
    })

    const handleClickFetchInfoDeposit = async (idmovimiento) => {

        const { FormDeposit: { onResetForm, formState: { idpago } } } = Forms
        const { setModalOpeningMode } = globalStates

        const { fetchInfoDeposit } = FetchData
        const { setParamsToSearch, executeFetchInfoDeposit } = fetchInfoDeposit

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()

        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({ idmovimiento: idmovimiento })
        await executeFetchInfoDeposit()

        setModalOpeningMode('READONLY')

        setDataModal(prevState => ({
            ...prevState,
            titleModal: 'Deposito',
            componentModal: 'deposits-section',
        }))
        // handleClickShowModal('', 'Formulario de depositos', 'deposits-section', {idpago}, 'READONLY')

    }


    const handleClickReturnModal = async (idmovimiento) => {

        const { FormDeposit: { onResetForm } } = Forms


        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()

        setDataModal(prevState => ({
            ...prevState,
            titleModal: 'Tabla de Depositos',
            componentModal: 'deposits-table',
        }))

    }

    const handleChangeCredit = async (value) => {

        const { FormRequestGlobal: { setFormState, onSelectSearchChange } } = Forms
        const { fetchAllCreditsPayments: { setParamsToSearch, executeFetchAllCreditPayments } } = FetchData


        onSelectSearchChange({ target: { name: 'idcredito', value: value.value } })
        setParamsToSearch({ idcredito: value.value })
        setFormState(prevState => ({
            ...prevState,
            'idcredito': value.value
        }))
        executeFetchAllCreditPayments()

    }

    const onSubmitFormAbono = withPending('submitAbono', async (e) => {
        e.preventDefault()

        const { FormDeposit, FormRequestGlobal } = Forms
        const { formState, onResetForm } = FormDeposit
        const formStateGlobal = FormRequestGlobal.formState

        const { fetchAllCreditsPayments: { executeFetchAllCreditPayments } } = FetchData

        const { getCurrentDate, extractIdVehicle } = Helpers

        const { isConfirmed } = await Swal.fire({
            title: '¿Está seguro de procesar este abono?',
            text: 'Una vez procesado, esta operación no podrá revertirse.',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Confirmar',
            cancelButtonText: 'Cancelar'
        })

        if (!isConfirmed) return

        if (formState.movimiento_tipo === 'EFECTIVO') {

            const _data = {
                idpago: formStateGlobal.idpago,
                idcaja: formState.idcaja,
                movimiento_tipo: formState.movimiento_tipo,
                deposito_fecha: formState.deposito_fecha,
                deposito_usuario: user.username,
                deposito_monto: parseFloat(formState.deposito_monto),
                deposito_moneda: formState.deposito_moneda,
                deposito_tipo_cambio: parseFloat(formState.deposito_tipo_cambio),
                deposito_quetzal: parseFloat(formState.deposito_quetzales),
                deposito_dolares: parseFloat(formState.deposito_dolares),
                deposito_observaciones: formState.deposito_observaciones,
                usuario_creo: user.username,
                fecha_creo: getCurrentDate(),
            }

            await marvarApi.post(`/vehicle/mgmt-payments/create-abono-cash`, _data)
                .then(({ data }) => {

                    alertMessage(data)

                    if (data.title === 'OK') {
                        onResetForm()
                        executeFetchAllCreditPayments()
                        closeModal()
                    }

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }
        closeModal()
    })

    const handleClickDownloadTicket = withPending('downloadTicket', async (idmovimiento) => {
        try {
            const response = await marvarApi.get(`/credits/mgmt-payments/get-deposit-by-ID/${idmovimiento}`)
            if (response.data.title === 'OK') {
                const _dataForPDF = {
                    idmovimiento: response.data.data.idmovimiento,
                    aprobacion_check: response.data.data.aprobacion_check,
                    datos_cliente: response.data.data.nombre_cliente,
                    movimiento_quetzales: numberFormatter.format(response.data.data.deposito_quetzal),
                    deposito_fecha: response.data.data.deposito_fecha,
                    contrato_codigo: `CRED${response.data.data.idcredito}`,
                    movimiento_tipo: response.data.data.movimiento_tipo,
                    movimiento_monto: numberFormatter.format(response.data.data.deposito_monto),
                    deposito_moneda: response.data.data.deposito_moneda,
                    deposito_tipo_cambio: response.data.data.deposito_tipo_cambio,
                    movimiento_dolares: numberFormatter.format(response.data.data.deposito_dolares),
                    pago_saldo_anterior: numberFormatter.format(response.data.data.pago_saldo_anterior),
                    pago_mora: numberFormatter.format(response.data.data.pago_mora),
                    pago_exoneracion: numberFormatter.format(response.data.data.pago_exoneracion),
                    pago_gastos: numberFormatter.format(response.data.data.pago_gastos),
                    pago_intereses: numberFormatter.format(response.data.data.pago_intereses),
                    pago_amortizacion: numberFormatter.format(response.data.data.pago_amortizacion),
                    pago_abono_capital: numberFormatter.format(response.data.data.pago_abono_capital),
                    descripcion_caja: response.data.data.nombre_caja,
                    descripcion_banco: response.data.data.nombre_banco,
                    boleta_numero: response.data.data.boleta_numero,
                    aprobacion_referencia_ach: response.data.data.aprobacion_referencia_ach,
                    deposito_observaciones: response.data.data.deposito_observaciones,
                    aprobacion_observaciones: response.data.data.aprobacion_observaciones,
                    fecha_cuota: response.data.data.fecha_cuota
                }

                drawPaymentTicket(pdfManager, _dataForPDF)
            }
        } catch (e) {
            console.log('API ERROR: ', e)
        }
    })

    return Object.freeze({
        pending,
        handleClickSearchPayments,
        handleKeyDown,
        handleClickShowModal,
        handleClickCloseModal,
        handleChangeAmount,
        handleChangeTypeCurrency,
        handleChangeExchangeRate,
        handleClickDownloadImage,
        onSubmitFormDeposits,
        handleClickFetchInfoDeposit,
        handleClickReturnModal,
        handleClickFechtVehicleCredits,
        handleChangeCredit,
        onSubmitFormAbono,
        handleClickDownloadTicket,
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { title, message } = res
        if (title === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}